var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualificationTranslater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.689941,
    y: 1.21033,
    width: 15.2231,
    height: 17.5862,
    stroke: "#F5F5F5",
    strokeWidth: 1.06829
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22852 5.41663H12.3742",
    stroke: "#F5F5F5",
    strokeWidth: 1.06829
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22852 8.08728H12.3742",
    stroke: "#F5F5F5",
    strokeWidth: 1.06829
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22852 10.7579H12.3742",
    stroke: "#F5F5F5",
    strokeWidth: 1.06829
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22852 13.4288H8.59649",
    stroke: "#F5F5F5",
    strokeWidth: 1.06829
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualificationTranslater);
export default __webpack_public_path__ + "static/media/qualification-translater.594de311cf69445c065a333e4adfaf9c.svg";
export { ForwardRef as ReactComponent };